const seeMore = {
	el: {
		seeMore: document.querySelector('.js-see-more'),
		heroHP: document.querySelector('.hero-hp')
	},

	events() {
		this.fxHandleScroll()

		this.el.seeMore.addEventListener('click', this.fxHeroScroll)
		window.addEventListener('scroll', this.fxHandleScroll)
	},

	fxHandleScroll() {
		if(window.scrollY > 5) {
			seeMore.el.seeMore.classList.add('hero-hp__see-more--hidden')
		} else {
			seeMore.el.seeMore.classList.remove('hero-hp__see-more--hidden')
		}
	},

	fxHeroScroll() {
		const heroNextSibling = seeMore.el.heroHP.nextElementSibling

		heroNextSibling.scrollIntoView({ behavior: 'smooth' })
	},

	init() {
		if (this.el.seeMore) {
			this.events()
		}
	}
}

seeMore.init()
